module.exports = __webpack_public_path__ + "static/img/advertising2.8ddf68e1.png";